import React from 'react';
import {Icons} from '@learningblocks/exp-constants';
import {Button, Colours} from '@learningblocks/shared-components';
import './style.scss';

const {IconStart} = Icons;

export class ErrorLimitExceeded extends React.Component {
  restartSimulation = () => {
    window.location.reload();
  };
  render() {
    return (
      <div className='exceedLimit'>
        <div className='exceedLimit-title'>
          <h2>
            You made too many mistakes, but not to worry - you can try again.
          </h2>
        </div>
        <div className='exceedLimit-button'>
          <Button
            aria-label='Start simulation button'
            tabIndex={4}
            onClick={this.restartSimulation}>
            <IconStart style={START_ICON_STYLE} />
            Restart simulation
          </Button>
        </div>
      </div>
    );
  }
}

const START_ICON_STYLE = {
  color: Colours.colorNeutralGray1,
  height: '16px',
  top: '2px',
};
